import { Navigate } from 'react-router';
import { useMe } from './hooks';

/**
 * Wrapper genérico que garante usuário autenticado antes de renderizar
 * `children`. Sem isso, rotas tipo /settings expõem conteúdo (tema, atalhos)
 * pra deslogado e ficam fora de paridade com /painel.
 *
 * Não inclui checks específicos de plataforma (twitch + scopes em /painel,
 * etc) — esses ficam dentro da rota porque dependem de regras de domínio.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div role="status" aria-live="polite" className="p-6 text-sm text-fg-muted">
        Carregando…
      </div>
    );
  }
  if (!me) return <Navigate to="/auth/connect" replace />;
  return <>{children}</>;
}
